import axios from 'axios';
import { message } from 'ant-design-vue';
import store from '../store';
import { getToken } from '@/utils/auth';
import {
  getRuntimeToken,
  getRuntimeUserID,
  isRuntimeChatType,
} from '@/utils/chat_runtime_params';
import { getMfaDeviceId, getMfaDeviceSignature } from '@/utils/mfa_device_signature';

let baseUrl = window.location.origin + '/api';
// if (process.env.NODE_ENV == 'production') {
//   baseUrl = 'https://console.situne.shop/api';
// } else
if (process.env.NODE_ENV == 'test') {
  baseUrl = 'http://api.ttcard.store/api';
} else if (
  process.env.NODE_ENV == 'dev' ||
  process.env.NODE_ENV == 'development'
) {
  baseUrl = 'http://api.ttcard.store/api';
} else if (process.env.NODE_ENV == 'production') {
  baseUrl = 'https://api.gx.cardsnaija.store/api';
} else if (process.env.NODE_ENV == 'staging') {
  baseUrl = 'https://api.gx.paykard.vip/api';
}

// 创建axios实例
const instance = axios.create({
  baseURL: baseUrl, // api的base_url
});

const closeCurrentChatPage = () => {
  window.close();
};

// request拦截器
instance.interceptors.request.use(
  async (config: any) => {
    config.headers.Source = 'chat'; //聊天
    // config.headers.TimeZone = `${0 - new Date().getTimezoneOffset() / 60}`;
    if (config.method == 'post' && !config.data) {
      config.data = {};
    }
    const uid = getRuntimeUserID();
    const tokenHeader = getRuntimeToken();
    const [deviceProof, macAddress] = await Promise.all([
      getMfaDeviceSignature(),
      getMfaDeviceId(),
    ]).catch((code) => {
      throw new Error(`MFA device identity unavailable: ${String(code)}`);
    });
    if (uid) {
      config.headers['uid'] = uid;
    }
    if (tokenHeader) {
      config.headers['token'] = tokenHeader;
    }
    config.headers['X-Device-Proof'] = window.btoa(deviceProof);
    config.headers.macAddress = macAddress;

    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

// respone拦截器
instance.interceptors.response.use(
  function (response: any) {
    const res = response.data;
    if (res?.code === 402) {
      closeCurrentChatPage();
      return Promise.reject(res);
    }
    if (res.success) {
      return response.data;
    }
    
    if (!res.success && !isRuntimeChatType('tk_oss')) {
      // 401:未登录; // type=tk_oss 渠道不做登出提示
      if (res.code === 405) {
        message.error('您已被登出！请重新登录');
        setTimeout(() => {
          window.close();
        }, 1000);
        store.dispatch('FedLogOut').then(() => {
          // location.reload(); // 为了重新实例化vue-router对象 避免bug
        });
      } else {
        message.error(res.message, 3);
      }
      return Promise.reject('error');
    } else {
      return response.data;
    }
  },
  function (error: any) {
    console.log('err' + error); // for debug
    if (
      error?.response?.status === 402 ||
      error?.response?.data?.code === 402
    ) {
      closeCurrentChatPage();
      return Promise.reject(error);
    }
    message.error(error.message, 3);
    return Promise.reject(error);
  }
);
export default instance;
